import { Phone, MessageCircle, Facebook, Instagram, Mail, ArrowUp } from "lucide-react";
import {
  waLink,
  PHONE,
  PHONE_DISPLAY,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  EMAIL,
} from "../lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[var(--fb-ink)] text-white pt-16 md:pt-24 pb-8"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative fb-container">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src="/brand/full.png"
              alt="Florentin Contractors"
              className="h-24 md:h-28 w-auto object-contain"
              loading="lazy"
            />
            <p className="mt-6 text-white/65 text-sm md:text-[15px] leading-relaxed max-w-md pretty">
              Construcción general, refacciones, remodelaciones y pérgolas con
              atención personalizada y compromiso en cada detalle.
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp mt-8"
              data-testid="footer-whatsapp-btn"
            >
              <MessageCircle className="h-5 w-5" strokeWidth={2.4} />
              Solicitar presupuesto
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.18em] text-white/45 mb-4">
              Navegación
            </div>
            <ul className="space-y-2.5 text-white/80 text-sm">
              <li>
                <a href="#inicio" className="hover:text-[var(--fb-accent)] transition-colors">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#nosotros" className="hover:text-[var(--fb-accent)] transition-colors">
                  Nosotros
                </a>
              </li>
              <li>
                <a href="#servicios" className="hover:text-[var(--fb-accent)] transition-colors">
                  Servicios
                </a>
              </li>
              <li>
                <a href="#trabajos" className="hover:text-[var(--fb-accent)] transition-colors">
                  Trabajos
                </a>
              </li>
              <li>
                <a href="#contacto" className="hover:text-[var(--fb-accent)] transition-colors">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.18em] text-white/45 mb-4">
              Contacto
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/85 hover:text-[var(--fb-accent)] transition-colors"
                >
                  <MessageCircle className="h-4 w-4" />
                  WhatsApp: {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PHONE.replace(/\s+/g, "")}`}
                  className="flex items-center gap-3 text-white/85 hover:text-[var(--fb-accent)] transition-colors"
                >
                  <Phone className="h-4 w-4" />
                  Teléfono: {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 text-white/85 hover:text-[var(--fb-accent)] transition-colors break-all"
                >
                  <Mail className="h-4 w-4 shrink-0" />
                  {EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/85 hover:text-[var(--fb-accent)] transition-colors"
                >
                  <Facebook className="h-4 w-4" />
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="flex items-center gap-3 text-white/85 hover:text-[var(--fb-accent)] transition-colors"
                >
                  <Instagram className="h-4 w-4" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-white/45 text-xs">
            © {year} Florentin Contractors. Todos los derechos reservados.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 text-xs text-white/55 hover:text-white transition-colors uppercase tracking-[0.18em]"
            data-testid="footer-scroll-top-btn"
          >
            Volver arriba
            <ArrowUp className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
}
